<template>
  <div class="receiverList">
    <div class="query">
      <div style="display: flex; align-items: center; max-width: 400px">
        <div style="min-width: 80px">连接状态：</div>
        <el-select
          size="small"
          v-model="statusSelect"
          placeholder="请选择"
          @change="statusChange"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div
      style="display: flex; align-items: center; justify-content: space-between"
    >
      <div class="pageTitle" style="line-height: 40px">
        {{ $t("label.open.page_title") }}
      </div>
      <div class="operate-btn">
        <el-button type="primary" class="btn" size="small" @click="add_btn">{{
          $t("label.open.add")
        }}</el-button>
        <el-button
          type="danger"
          class="btn"
          size="small"
          @click="delete_batch"
          >{{ $t("label.open.delete_btn") }}</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        ref="tableData"
        stripe
        @selection-change="handleSelectionChange"
        :height="tableHeight"
      >
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <!-- <el-table-column align="center" type="index" width="55">
        </el-table-column> -->
        <el-table-column
          v-for="column in columns"
          :key="column"
          :prop="column"
          :label="$t(`label.open.${column}`)"
          align="center"
          :min-width="column == 'operate' ? '150px' : '100px'"
        >
          <template slot-scope="{ row }">
            <template v-if="column == 'status'">
              <span v-if="row.status === 1" style="color: #3e916a">
                {{ $t("label.receiverList.link") }}
              </span>
              <span v-else style="color: #ce0000">
                {{ $t("label.receiverList.break") }}
              </span>
            </template>
            <template
              v-else-if="column == 'device_manage' || column == 'data_push'"
            >
              <el-button
                type="success"
                size="small"
                @click="operateBtn(column, row)"
                >{{
                  column == "device_manage"
                    ? $t("label.open.add_btn")
                    : $t("label.open.push_btn")
                }}</el-button
              >
              <el-button
                type="warning"
                size="small"
                @click="operateBtn('view_btn', row)"
                >{{ $t("label.open.view_btn") }}</el-button
              >
            </template>
            <template v-else>
              {{ row[column] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        :total="total"
        popper-class="mySelectType"
        :current-page="page"
        @size-change="sizeChange"
        @current-change="currentChange"
      >
      </el-pagination>
    </div>
    <EditSN
      :row="opt_item"
      :show="showAddDevice"
      @toggleShow="toggleShowAddDevice"
    ></EditSN>
    <AddManu
      :show="showAddManu"
      @toggleShow="toggleShowAddManu"
      @refush="getManuList"
    ></AddManu>
    <ViewDevice
      :row="opt_item"
      :show="showViewDevice"
      @toggleShow="toggleShowViewDevice"
    ></ViewDevice>
  </div>
</template>

<script>
import { getDeviceList, getThirdList, batchDeleteThird } from "@/api/index";
import ViewDevice from "./component/ViewDevice.vue";
import AddManu from "./component/addManu.vue";
import EditSN from "./component/editSN.vue";
// import DisReceiver from "./component/disReceiverList.vue";
export default {
  data() {
    return {
      options: [
        {
          value: "1",
          label: "连接",
        },
        {
          value: "2",
          label: "断开",
        },
      ],
      opt_item: {},
      statusSelect: "", // 链接状态
      // queryData: {
      //   type: "sn",
      //   keyWords: "",
      // },
      columns: [
        "index",
        "manufacturer",
        "link_status",
        "last_push_time",
        "push_times",
        "device_manage",
        // "data_push",
      ],
      tableData: [],
      total: 0,
      page: 1,
      pageSize: 10,
      searchType: "sn",
      sn: "",
      ownership: "",
      fileList: [],
      showAddDevice: false,
      showAddManu: false,
      showViewDevice: false,
      showDis: false,
      choose: [],
      selectValue: [],
      tableHeight: 450,
    };
  },
  components: {
    ViewDevice,
    AddManu,
    EditSN,
  },
  watch: {
    "$store.getters.deviceInfo": {
      handler(val) {
        this.$nextTick(() => {
          this.$refs.tableData.doLayout();
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // receiverList
    this.getManuList();
    this.$nextTick(() => {
      // window.innerHeight 浏览器窗口的可见高度，下面的 220 是除了table最大高度的剩余空间。
      let height =
        window.innerHeight - this.$refs.tableData.$el.offsetHeight + 200;
      this.tableHeight = height;
    });
  },
  methods: {
    add_btn() {
      // 添加厂商
      this.toggleShowAddManu();
    },
    delete_batch() {
      //  批量删除
      if (!this.choose.length) {
        this.$message({
          type: "warning",
          message: "请先选择厂商",
        });
        return;
      }
      this.$confirm("此操作将永久删除该厂商, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = {
            id: this.choose,
          };
          batchDeleteThird(params).then((res) => {
            console.log(res, res.data, "---");
            console.log(res, "---");
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              this.getManuList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //
    statusChange(e) {
      this.getManuList();
    },
    // 跳转流速球详情
    operateBtn(e, row) {
      this.opt_item = row;
      if (e == "device_manage") {
        // 打开添加弹框
        this.toggleShowAddDevice();
      } else if (e == "data_push") {
        // 推送
      } else if (e == "view_btn") {
        this.toggleShowViewDevice();
      }
    },
    // 改变搜索条件搜索
    selectChange(e) {
      this.searchType = e;
      console.log(e);
    },
    // 搜索
    searchList() {
      this.page = 1;
      console.log(this.queryData.keyWords);
      // if (this.searchType === "sn") {
      //   (this.sn = this.queryData.keyWords), (this.ownership = "");
      // } else {
      //   (this.sn = ""), (this.ownership = this.queryData.keyWords);
      // }
      this.getManuList();
    },
    getManuList() {
      let param = {
        page_num: this.page,
        page_size: this.pageSize,
        // sn: this.sn,
        status: this.statusSelect,
      };
      console.log("刷新列表");
      this.tableData = [];

      getThirdList(param).then((res) => {
        if (res.code == 200) {
          this.tableData = res.data.third_push_info.map((_f, _i) => {
            return {
              index: _i + 1,
              manufacturer: _f.name,
              link_status: _f.status == 1 ? "连接" : "断开",
              last_push_time: _f.last_push,
              push_times: _f.num,
              // "device_manage",
              ..._f,
            };
          });
        }
      });
    },

    // 选择设备
    handleSelectionChange(e) {
      this.choose = e.map((_f) => {
        return _f.id;
      });
    },
    toggleShowAddDevice() {
      this.showAddDevice = !this.showAddDevice;
    },
    toggleShowViewDevice() {
      this.showViewDevice = !this.showViewDevice;
    },
    toggleShowAddManu() {
      this.showAddManu = !this.showAddManu;
    },
    closeDis() {
      this.showDis = false;
    },
    // 分页
    sizeChange(e) {
      this.pageSize = e;
      this.getManuList();
    },
    // 页数
    currentChange(e) {
      this.page = e;
      // console.log("页数", e);
      this.getManuList();
    },
    // 提交清除数据的选中状态
    searchTableData() {
      this.$refs.tableData.clearSelection(); //清除选中的数据
    },
  },
};
</script>

<style lang="scss" scoped>
.receiverList {
  padding: 20px;

  .query {
    display: flex;
    align-items: center;
    // justify-content: space-between;
  }

  .input-width {
    max-width: 400px;
  }

  .operate-btn {
    display: flex;
  }

  .btn {
    min-width: 80px;
    height: 32px;
  }

  .table {
    margin-top: 10px;
    border-radius: 2px 2px 0px 0px;
    overflow: hidden;

    &::v-deep th.el-table__cell {
      background-color: $table_header;
      color: #fff;
    }

    &::v-deep td.el-table__cell {
      background: transparent !important;
    }

    &::v-deep .el-table__row--striped {
      background-color: #d2e9ce;
    }
  }

  .pagination {
    // display: flex;
    // align-items: center;
    // justify-content: flex-end;
    // margin-top: 12px;
    position: fixed;
    bottom: 0px;
    right: 20px;
    // width: 100%;
    display: flex;
    justify-content: flex-end;
    background-color: #ffffff;
    z-index: 999;
    padding-bottom: 6px;
  }

  ::v-deep {
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #3b9167;
      color: #fff;
    }

    .el-pagination.is-background .btn-next,
    .el-pagination.is-background .btn-prev,
    .el-pagination.is-background .el-pager li {
      background-color: #ffffff;
      border: 1px solid #e8e8e8;
    }

    .el-pagination.is-background .el-pager li:hover {
      color: #3b9167;
    }

    .el-pagination__sizes .el-input .el-input__inner:hover {
      border-color: #3b9167;
    }

    .el-select .el-input__inner:focus {
      border-color: #3b9167;
    }

    .el-select-dropdown__item.selected {
      color: #3b9167 !important;
    }

    .el-button--success.is-disabled {
      background-color: #c0c4cc;
      border-color: #c0c4cc;
    }

    // .el-pagination.is-background .el-pager li:not(.disabled):hover {
    // 	color: #3b9167;
    // }
  }
}
</style>
<style lang="scss">
.mySelectType {
  .el-select-dropdown__item.selected {
    color: #3b9167 !important;
  }
}
</style>
